export const getSelectedCampaign = (search, campaigns) => {
  const query = search.substr(1)
  const idCampaigns = query
    .split('&')
    ?.filter((param) => param.includes('idCampaign'))
    .map((campaignId) => decodeURIComponent(campaignId).replace('idCampaign[]=', ''))
  return campaigns.find((item) => idCampaigns?.includes(item.id))
}
